document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "#planning-trouble-get", function(){
    const id = $("input[name='id']").val()
    
    loadModal({
      title: "Trouble",
      url: "/dashboard/troubles/" + id
    })
  })
})